module.exports = __webpack_public_path__ + "assets/img/Katalog_2024_Neu.463afa84.jpg";